// extracted by mini-css-extract-plugin
module.exports = {"faqContainer":"premiumPlanFaq_faqContainer__n3TX3","heading":"premiumPlanFaq_heading__9aKWS","faqButton":"premiumPlanFaq_faqButton__FvsFY"};